import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const DeliveryFees = () => import('./views/Index.vue');

export default [
  {
    path: '/delivery-fees',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'DeliveryFees',
        component: DeliveryFees,
        meta: { title: i18n.global.t('main.deliveryFees') },
      },
    ],
  },
];
